module.exports = __webpack_public_path__ + "static/media/SK.e995322e.svg";